import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";
import { AdminService } from "src/app/admin.service";
import { MatDialog } from '@angular/material/dialog';
import { OrdersTripViewComponent } from '../orders-trip-view/orders-trip-view.component';

@Component({
  selector: "app-payments",
  templateUrl: "./payments.component.html",
  styleUrls: ["./payments.component.css"],
})
export class PaymentsComponent implements OnInit {
  token: any;
  paymentArray: any;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  @Input() min: any;
  minDate = new Date();
  paymentForm: FormGroup;
  totalReceivable: number = 0;
  taxDetails: any;
  actualReceivable: number = 0;
  totalTaxPercent: number = 0;
  totalDeduction: number = 0;
  calculatedTax: any;
  s9Payment: number = 0;
  paymentInfo: any = [];
  paymentAmount: any = [];
  loading: boolean = false;
  truckNumber: any = -1;
  tripId: any = -1;
  status: any = -1;
  page: any = 1;
  perPage: any = 10;
  perPageList: any = 10;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  search_Number: any;
  search_TripID: any;
  from_Date: any;
  to_Date: any;
  search_BTN: boolean = true;
  clear_search_BTN: boolean = false;
  constructor(
    private services: TruckOwnerService,
    private formBuilder: FormBuilder,
    private datepipe: DatePipe,
    private snackBar: MatSnackBar,
    private router: Router,
    private adminServices: AdminService,
    private matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.tripsGet(this.tripId);
    // this.getAllS9PaidTrips();
    this.paymentForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      truck_number: [""],
      trip_id: [""],
    });
    let triptype = "payments";
    sessionStorage.setItem("tripType", triptype);
  }


  tripsGet(type: any) {
    this.tripId = type;
    const dateObj = {
      from_date: -1,
      to_date: -1,
      truck_number: -1,
    };
    this.loading = true;

    this.services
      .paymentsGet(
        dateObj,
        this.status,
        this.tripId,
        this.perPageList,
        this.page,
        this.token
      )
      .subscribe(
        (response: any) => {
          this.paymentArray = response.body.data || [];

          const summary = response.body.paymentSummary || {};
          this.totalReceivable = summary.totalReceivable || 0;
          this.totalDeduction = summary.totalDeduction || 0;
          this.actualReceivable = this.totalReceivable - this.totalDeduction;
          this.s9Payment = summary.s9Paid || 0;

          this.loading = false;
        },
        (error) => {
          this.loading = false;
          if (error.status == 404) {
            this.paymentArray = [];
            return;
          }
          if (
            error.error.message === "jwt malformed" ||
            error.error.message === "jwt expired"
          ) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", { duration: 5000 });
        }
      );
  }

  calculateAmount(item: any): number {
    if (!item || !item.userInfo.user_type) return 0; // Ensure item exists

    if (item.userInfo.user_type === "corporate") {
      const isUnloaded =
        item?.workOrderInfoInfo?.[0]?.pay_as_load_quantity ===
        "unloaded_quantity";
      const quantity = isUnloaded
        ? Number(item?.workOrderOtherDetails?.unloading_point) || 0
        : Number(item?.workOrderOtherDetails?.loading_point) || 0;
      const pricePerTon =
        Number(item?.workOrderOtherDetails?.price_per_ton) || 0;
      return quantity * pricePerTon;
    } else if (item.userInfo.user_type === "customer") {
      const actualPrice =
        Number(item?.paymentInfo?.[0]?.price_details.actual_price) || 0;
      return actualPrice;
    }

    return 0;
  }

  calculateDeductions(item: any): number {
    if (!item || item.userInfo?.user_type !== "customer") return 0;
  
    const routeFare = Number(item?.driverRouteInfo?.[0]?.route_fare) || 0;
    const totalFare = Number(item?.driverRouteInfo?.[0]?.total_fare) || 0;
  
    return routeFare - totalFare;
  }

  viewTripSummary(item: any): void {
    this.matDialog.open(OrdersTripViewComponent, {
      width: '80vw',
      height: '80vh',
      data: item,
      autoFocus: false
    });
  }

  formatNumber(value: number): string {
    return Math.floor(value).toString();
  }

  dataSearch() {
    // var fromDate = this.datepipe.transform(
    //   this.paymentForm.value.from_date,
    //   "yyyy-MM-dd"
    // );
    // var toDate = this.datepipe.transform(
    //   this.paymentForm.value.to_date,
    //   "yyyy-MM-dd"
    // );

    let fromDate: string | null = null;
    let toDate: string | null = null;
    if (this.paymentForm.value.from_date) {
      const f = new Date(this.paymentForm.value.from_date);
      fromDate = new Date(Date.UTC(
        f.getFullYear(),
        f.getMonth(),
        f.getDate(),
        0, 0, 0, 0
      )).toISOString();
    }
    if (this.paymentForm.value.to_date) {
      const t = new Date(this.paymentForm.value.to_date);
      toDate = new Date(Date.UTC(
        t.getFullYear(),
        t.getMonth(),
        t.getDate(),
        23, 59, 59, 999
      )).toISOString();
    }
    const dateObj = {
      from_date: fromDate,
      to_date: toDate,
      truck_number: this.paymentForm.value.truck_number || this.truckNumber,
    };
    this.services
      .paymentsGet(
        dateObj,
        this.status,
        this.tripId,
        this.perPage,
        this.page,
        this.token
      )
      .subscribe((response: any) => {
        this.paymentArray = response.body.data;
        this.search_btn = false;
        this.clear_btn = true;

        const summary = response.body.paymentSummary || {};
        this.totalReceivable = summary.totalReceivable || 0;
        this.totalDeduction = summary.totalDeduction || 0;
        this.actualReceivable = this.totalReceivable - this.totalDeduction;
        this.s9Payment = summary.s9Paid || 0;
      });
  }
  
  // console array of s9 paid trips. 
  // getAllS9PaidTrips(): void {
  //   const dateObj = {
  //     from_date: -1,
  //     to_date: -1,
  //     truck_number: -1,
  //   };
  
  //   this.services
  //     .paymentsGet(dateObj, this.status, this.tripId, this.perPageList, this.page, this.token)
  //     .subscribe(
  //       (response: any) => {
  //         const allPayments = response.body.data || [];
  
  //         const s9PaidTrips = allPayments
  //           .filter((payment: any) =>
  //             payment.truckownerPaymentInfo &&
  //             payment.truckownerPaymentInfo.some((info: any) => info.transaction_amount > 0)
  //           )
  //           .map((payment: any) => ({
  //             trip_id: payment._id,
  //             truck_number: payment.truck_number,
  //             paidAmounts: payment.truckownerPaymentInfo
  //               .filter((info: any) => info.transaction_amount > 0)
  //               .map((info: any) => info.transaction_amount),
  //           }));
  
  //         console.log("🟢 All S9 Paid Trips:", s9PaidTrips);
  //       },
  //       (error) => {
  //         console.error("Error fetching all payments for S9-paid trips:", error);
  //       }
  //     );
  // }
  
  searchTripId(value: string) {
    if (value == "") {
      this.tripId = -1;
      this.tripsGet(this.tripId);
    } else {
      this.clear_search_BTN = true;
      this.search_BTN = false;
      this.tripsGet(value);
    }
  }

  resetTruckTrackInfo() {
    this.search_Number = "";
    (this.from_Date = ""), (this.to_Date = "");
    this.clear_btn = false;
    this.search_btn = true;
    this.tripId = -1;
    this.tripsGet(this.tripId);
  }

  resetTripId() {
    this.search_TripID = "";
    this.clear_search_BTN = false;
    this.search_BTN = true;
    this.tripId = -1;
    this.tripsGet(this.tripId);
  }
}
